<div>
  <h2 mat-dialog-title>Transaction {{!data.hash ? 'signing' : (!data.receipt ? 'broadcasting' : 'confirming')}}</h2>
  <div mat-dialog-content>
    <p [hidden]="!data.hash" class="overflow-elipsis">Tx Id: {{data.hash}}</p>
    <p [hidden]="data.hash">...</p>
    <p>{{data.confirmations}} confirmation{{data.confirmations > 1 || data.confirmations == 0 ? 's' : ''}} so far, please wait for {{data.confsRequired}} confirmation{{data.confsRequired > 1 ? 's' : ''}} to continue...</p>
    <p>Do not close this page.</p>
  </div>
</div>
